import { isPositiveNumber, reduce } from "et3-type-guards";
import React from "react";
import { useLocation } from "react-router";
import UserSearchForm from "../../../components/user-pages/UserSearchForm";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getUserStore from "../../../stores/user-store";
import getUserEditProfileStore from "../../../stores/user-store/edit-profile-store";
import ET3PageDiv from "../../../core/et3-page-div";
import UserEditProfileData from "./user-edit-profile-data";
import Et3Margin from "../../../core/et3-ui/ET3Margin";

const UserEditProfile = withLiteObserverAndTheme(() => {
  const location = useLocation();
  React.useEffect(() => {
    const search = reduce(() => location.search, "");
    getCoreHistoryStore().setPageName("USER_EDIT_PROFILE", "USER_EDIT_PROFILE");
    getUserEditProfileStore().checkURLSearch(search);
  }, []);
  const userID = getUserStore().userIdInput.get();

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("USER")}
        subTitle={i18n.get("USER_EDIT_PROFILE")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <UserSearchForm
        withPlatform={false}
        withLimit={false}
        disabled={!isPositiveNumber(userID)}
        onClickAction={async () => {
          getUserEditProfileStore().getUserEditProfile();
        }}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <UserEditProfileData />
    </ET3PageDiv>
  );
});
export default UserEditProfile;
